import * as React from 'react'
import * as styles from './account.settings.styl'
import cx from 'classnames'
import type { History } from 'history'
import { User } from '@src/redux/reducers/auth'
import { Routes } from '@src/constants/routes'
import { generateUrl } from '@src/utils/router.helpers'
import { getHTMLRoleBy } from '@src/utils/css.selector.helper'
import { getHasAuthHook, RightSetEnum } from '@src/utils/user.rights'
import WaitFeatureFlagContext from '@src/modules/feature.flags/components/wait.feature.flag.context'

export interface Props {
  user: User
  signOut: () => void
  history: History
  onOpenAboutUs: () => void
}
export interface MenuItemProps {
  className?: string
  onClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  title?: string
}
export const MenuItem: React.FC<MenuItemProps> = ({
  onClick,
  className,
  title,
  children
}: React.PropsWithChildren<MenuItemProps>) => (
  <div
    {...(getHTMLRoleBy(
      title || (children as string),
      'account-menu-nav-',
      'object'
    ) as { role: string })}
    className={cx(styles.menuItem, className)}
    onClick={onClick}
  >
    {title || children}
  </div>
)

const AccountSettings: React.FC<Props> = (props: Props) => {
  const { history, onOpenAboutUs, user, signOut } = props
  function goToProfileSettings() {
    if (history) {
      history.push(
        generateUrl(Routes?.pages?.settings?.path, { id: 'profile' })
      )
    }
  }

  function showAboutUs() {
    if (typeof onOpenAboutUs === 'function') {
      onOpenAboutUs()
    }
  }

  const isAdmin = getHasAuthHook(RightSetEnum.GENERAL)
  return (
    <div role={'account-menu-content'} className={styles.content}>
      <div role={'signed-account'} className={styles.account}>
        {`Signed in as `}
        {user ? `${user.first_name} ${user.last_name}` : 'Not logged in'}{' '}
        {user?.userSource === 'COGNITO'
          ? `(Cognito)`
          : `${isAdmin ? `(Admin)` : `(User)`}`}
      </div>

      <MenuItem title="Settings" onClick={goToProfileSettings} />
      <MenuItem title="About Us" onClick={showAboutUs} />
      <WaitFeatureFlagContext flag="CAM_TEMP_20220623_IDN_LOGIN_PATH">
        {({ response }) => {
          return response?.value ? (
            <></>
          ) : (
            <MenuItem onClick={signOut} title="Logout" />
          )
        }}
      </WaitFeatureFlagContext>
    </div>
  )
}

export default AccountSettings
